export default from './OfferConfirmation';
